var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("iPASS MONEY付款說明")]),_c('ul',{staticClass:"has-type-decimal"},[_c('li',[_vm._v("使用 iPASS MONEY 恕不適用分期付款")]),_c('li',[_vm._v("iPASS MONEY 接受信用卡付款")]),_c('li',[_vm._v("付款額度限制：單筆 5 萬 / 每日限額 10 萬 / 每月限額 30 萬")]),_c('li',[_vm._v("詳情請見一卡通官網 > 常見問題")])])])
}]

export { render, staticRenderFns }